//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productCategorys', {
//        templateUrl: 'views/components/views/productCategorys/productCategorys.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'productCategorysService', function (stateService, productCategorysService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListProductCategories: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadProductCategories() {
//                vm.model.itemsListProductCategories = await productCategorysService.listProductCategories();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'productcategory':
//                        go({ productcategory_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadProductCategories();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
